import { CSSProperties } from 'react'

import FormIcon from '@assets/images/canvas-form-icon.svg?react'
import ObservationIcon from '@assets/images/canvas-observation-icon.svg?react'
import TaskIcon from '@assets/images/canvas-task-icon.svg?react'

import { Marker, MarkerType } from './type'

export const CSS_FILE_DEFAULT_PATH = '/webviewer/styles/custom_default.css'

export const WEB_VIEWER_PATH = '/webviewer/lib'
export const WEB_VIEWER_CORE_PATH = '/webviewer/lib/core'

export const UI_CONFIG_MOBILE_PATH = '/webviewer/lib/config/ui_config_mobile.json'
export const UI_CONFIG_SIMPLE_PATH = '/webviewer/lib/config/ui_config_simple.json'
export const UI_CONFIG_ADVANCED_PATH = '/webviewer/lib/config/ui_config_advanced.json'

export const MARKER_COLORS: Record<MarkerType, string> = {
  observation: '#f59e0b',
  form: '#f59e0b',
  task: '#f59e0b',
}

export const ICONS: Record<MarkerType, React.ComponentType<any>> = {
  observation: ObservationIcon,
  form: FormIcon,
  task: TaskIcon,
}

export const LONG_PRESS_DURATION = 150

export const BASE_MARKER_STYLES: CSSProperties = {
  position: 'absolute',
  height: '56px',
  width: '56px',
  borderRadius: '8px',
  cursor: 'pointer',
  willChange: 'transform',
  transform: 'translateZ(0)',
  WebkitTransform: 'translateZ(0)',
  MozTransform: 'translateZ(0)',
  OTransform: 'translateZ(0)',
}

export const MARKER_ICON_STYLES: CSSProperties = {
  position: 'absolute' as const,
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  zIndex: 2,
}

export const getMarkerIconStyle = (marker: Marker): CSSProperties => {
  const hasData = marker.data && marker.data.idNumber

  const baseStyle = {
    height: hasData ? '16px' : '24px',
  }

  if (marker.type === 'observation') {
    return {
      ...MARKER_ICON_STYLES,
      ...baseStyle,
      top: hasData ? '2px' : '15px',
      left: hasData ? '20%' : '50%',
      width: hasData ? '14px' : '24px',
    }
  }

  if (marker.type === 'form') {
    return {
      ...MARKER_ICON_STYLES,
      ...baseStyle,
      top: hasData ? '4px' : '17px',
      left: hasData ? '23%' : '55%',
      width: hasData ? '14px' : '24px',
    }
  }

  return {
    ...MARKER_ICON_STYLES,
    ...baseStyle,
    top: hasData ? '2px' : '15px',
    left: hasData ? '20%' : '50%',
    width: hasData ? '12px' : '24px',
  }
}

export const CLOSE_ICON_STYLES: CSSProperties = {
  position: 'absolute',
  right: '-8px',
  top: '-8px',
  backgroundColor: '#F3F4F6',
  borderRadius: '50%',
  padding: '3px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)',
  zIndex: 3,
}

export const CLOSE_ICON_IMAGE_STYLES: CSSProperties = {
  width: '16px',
  height: '16px',
}

export const BASE_LABEL_STYLES: CSSProperties = {
  position: 'absolute',
  top: '21px',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '14px',
  whiteSpace: 'nowrap',
}

export const STATUS_ICON_IMAGE_STYLES: CSSProperties = {
  width: '12px',
  height: '12px',
}

export const STATUS_ICON_STYLES: CSSProperties = {
  position: 'absolute',
  right: '-9px',
  top: '42px',
  zIndex: 3,
}

export const MARKER_CONTAINER_ID = 'marker-container'
